import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ssrSafeStorage } from './utils';

interface FavoriteLevelsState {
    favorite_levels: string[];
    addFavoriteLevel: (levelId: string) => void;
    removeFavoriteLevel: (levelId: string) => void;
    clearFavoriteLevels: () => void;
}
export const useFavoriteLevelsStore = create<FavoriteLevelsState>()(
    persist(
        (set) => ({
            favorite_levels: [],
            addFavoriteLevel: (id: string) => {
                set((state) => {
                    const newFavorites = [...state.favorite_levels, id];
                    return { favorite_levels: newFavorites };
                });
            },
            removeFavoriteLevel: (id: string) => {
                set((state) => {
                    const newFavorites = state.favorite_levels.filter(
                        (fav) => fav !== id,
                    );
                    return { favorite_levels: newFavorites };
                });
            },
            clearFavoriteLevels: () => {
                set({ favorite_levels: [] });
            },
        }),
        {
            name: 'favoriteLevels',
            storage: ssrSafeStorage,
        },
    ),
);
